import React, { useEffect, useState } from 'react';
import './BadgesUnlocked.css';

export default function BadgesUnlocked({ count = 3 }) {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRevealed(true);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  if (count <= 0) return null;

  return (
    <div className={`achievement-count-card ${isRevealed ? 'revealed' : ''}`}>
      <span className="achievement-count-label">BADGES UNLOCKED</span>
      
      <div className="achievement-count-row">
        {/* Compact CSS Gold Trophy */}
        <div className="compact-trophy">
          <div className="trophy-glow"></div>
          <div className="trophy-cup-shape">
            <div className="cup-rim-line"></div>
            <div className="cup-handle-shape left-h"></div>
            <div className="cup-handle-shape right-h"></div>
            <div className="cup-glint-line"></div>
          </div>
          <div className="trophy-stem-shape"></div>
          <div className="trophy-base-shape"></div>
        </div>

        {/* Counter Number */}
        <div className="achievement-number-display">
          <span>+{count}</span>
        </div>
      </div>
    </div>
  );
}